import {
  IFinancialReport,
  IGetFinancialDashboardPromiseResponse
} from '@domain/interfaces/dashboard/FinancialDashboard/IFinancialDashboard';

import { IGetStoresMarketingIntegrationsValuesResponse } from '@domain/interfaces/utils/multiStoreSelect/financialDashboard';

export const getStoresMarketingIntegrationsValues = (
  currentSelectedStoreFinancialReportData: IFinancialReport,
  selectedStoresData: IGetFinancialDashboardPromiseResponse[]
): IGetStoresMarketingIntegrationsValuesResponse => {
  const currentSelectedStoreFacebookAmountValue =
    currentSelectedStoreFinancialReportData?.marketing?.facebook_amount;

  const currentSelectedStoreFacebookTaxAmountValue =
    currentSelectedStoreFinancialReportData?.marketing?.facebook_tax_amount;

  const currentSelectedStoreGoogleAmountValue =
    currentSelectedStoreFinancialReportData?.marketing?.google_amount;

  const currentSelectedStoreTaboolaAmountValue =
    currentSelectedStoreFinancialReportData?.marketing?.taboola_amount;

  const storesFacebookAmountValues = selectedStoresData.map(
    (value) => value.financial_report?.marketing?.facebook_amount
  );

  const storesFacebookTaxAmountValues = selectedStoresData.map(
    (value) => value.financial_report?.marketing?.facebook_tax_amount
  );

  const storesGoogleAmountValues = selectedStoresData.map(
    (value) => value.financial_report?.marketing?.google_amount
  );

  const storesTaboolaAmountValues = selectedStoresData.map(
    (value) => value.financial_report?.marketing?.taboola_amount
  );

  const facebookAmountValues = [
    ...storesFacebookAmountValues,
    currentSelectedStoreFacebookAmountValue
  ];

  const facebookTaxAmountValues = [
    ...storesFacebookTaxAmountValues,
    currentSelectedStoreFacebookTaxAmountValue
  ];

  const googleAmountValues = [...storesGoogleAmountValues, currentSelectedStoreGoogleAmountValue];

  const taboolaAmountValues = [
    ...storesTaboolaAmountValues,
    currentSelectedStoreTaboolaAmountValue
  ];

  const reducedFacebookAmountValues = facebookAmountValues.reduce((totalValue, currentValue) => {
    return Number(totalValue) + Number(currentValue);
  });

  const reducedFacebookTaxAmountValues = facebookTaxAmountValues.reduce(
    (totalValue, currentValue) => {
      return Number(totalValue) + Number(currentValue);
    }
  );

  const reducedGoogleAmountValues = googleAmountValues.reduce((totalValue, currentValue) => {
    return Number(totalValue) + Number(currentValue);
  });

  const reducedTaboolaAmountValues = taboolaAmountValues.reduce((totalValue, currentValue) => {
    return Number(totalValue) + Number(currentValue);
  });

  return {
    facebook_amount: reducedFacebookAmountValues,
    facebook_tax_amount: reducedFacebookTaxAmountValues,
    google_amount: reducedGoogleAmountValues,
    taboola_amount: reducedTaboolaAmountValues
  };
};
